/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import apiClient from "../../utils/apiClient";

export const apiLicenseDelete = (
  data: number,
): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .delete(API_ENDPOINTS.LICENSE_DELETE.replace(":id", `${data}`))
    .then(response => ({ response }))
    .catch(error => ({ error }));
